import { Fragment } from "react";
import { inputClasses } from "../../styles/inputs";
import { COLORS } from "../../styles/defaults";
import Select from 'react-select';

export const Selector = ({ classes = [], options = [], onSelect, position="auto", defaultValue={}, placeholder }) => {
    const opts = options?.map((obj, indx) => {
        if(obj.id && !obj.label){ return {"value":obj.id, "label":obj.value} };
        return obj;
    });

    if(typeof onSelect != "function"){ onSelect = (selectedOption) => console.info("onSelect no definido:", selectedOption); }
    const inputClass = inputClasses();
    classes = classes.reduce((cls, c) => cls + " " + (inputClass[c]?inputClass[c]:""), "");

    const customClases = {
        control: (state) => `${classes} ${inputClass.input}`,
        // input: (state) => inputClass.input
    };
    const customStyles = {
        control: (base, state) => ({
            ...base,
            width:"100%!important",
            background:"#E2E5F0",
            borderStyle:"none",
            borderRadius:"12px"
        }),
        // option: (base, state) => ({}),
        singleValue: (base) => ({
            ...base,
            color:COLORS.primary.main
        })
    }

    //---> Busco el elemento seleccionado, en caso de haber mando un String;
    let selectedOption = defaultValue;
    if(typeof defaultValue != "object" && opts){
        for(let key in opts){
            if([opts[key].label, opts[key].value, key].includes(defaultValue)){
                selectedOption = opts[key];
                break;
            };
        };
    };

    //---> Si envío la imagen en las opciones;
    const CustomOption = (props) => {
      const { data, innerRef, innerProps } = props;
      return (
        <div ref={innerRef} {...innerProps} style={{ display: 'flex', alignItems: 'center' }}>
          <img src={data.image} alt={data.label} style={{ width: 20, height: 20, marginRight: 10 }} />
          <span>{data.label}</span>
        </div>
      );
    };

    return (
        <div style={{ width: "100%" }}>
            <Select
                classNames={customClases}
                styles={customStyles}
                // components={{ Option: CustomOption }} 
                // defaultValue={selectedOption}
                value={selectedOption} //---> Uso value; porque defaultValue solo funciona si las opts, cargan antes de mostrar la primera vez el componente;
                onChange={onSelect}
                options={opts}
                menuPlacement={position}
                placeholder={placeholder}
                noOptionsMessage={() => "No se encontraron opciones"}
              />
        </div>
    );
}